// Pengganti alert() / window.confirm() bawaan browser: notifikasi (Snackbar) dan dialog konfirmasi bergaya aplikasi.
// Dipakai dari mana saja tanpa hook:
//   notif.sukses('Tersimpan'); notif.error('Gagal ...'); notif.info(...); notif.peringatan(...)
//   if (!(await konfirmasi('Hapus cabang ini?'))) return;     // fungsi pemanggil harus async
// Ditampilkan oleh <DialogHost /> (dipasang sekali di App.js).
const pendengar = new Set();
const kirim = (kejadian) => {
  if (pendengar.size === 0) {
    // DialogHost belum terpasang: jangan menjatuhkan aksi pengguna secara diam-diam.
    if (kejadian.jenis === 'konfirmasi') kejadian.resolve(false);
    // eslint-disable-next-line no-console
    console.warn('DialogHost belum terpasang:', kejadian.pesan || kejadian.text);
    return;
  }
  pendengar.forEach((fn) => fn(kejadian));
};

const kirimNotif = (severity) => (text) => kirim({ jenis: 'notif', severity, text: String(text ?? '') });

export const notif = {
  sukses: kirimNotif('success'),
  error: kirimNotif('error'),
  info: kirimNotif('info'),
  peringatan: kirimNotif('warning'),
};

/** Dialog Ya/Batal. Mengembalikan Promise<boolean>. opsi: { judul, tombolYa, bahaya } */
export const konfirmasi = (pesan, opsi = {}) =>
  new Promise((resolve) => kirim({ jenis: 'konfirmasi', pesan: String(pesan ?? ''), ...opsi, resolve }));

export const berlangganan = (fn) => {
  pendengar.add(fn);
  return () => pendengar.delete(fn);
};
